var $blocoVideos;
var clssBlocoHighlight = "bloco-hightlight";
var forceShow = false;
var videoScreenTarget = "desktop";

$(document).ready(function () {
  $blocoVideos = $(".colvideos--bloco-video");
  $blocoUntilMobile = $(".acoeshoc--grid-videos.until-mobile");
  $blocoFromMobile = $(".acoeshoc--grid-videos.from-mobile");
  $iframeVideo = $(".iframe-video");

  // hover das imagens
  // $blocoVideos.hover(function(){
  //     $(this).find(".box-infos").addClass("bloco-foto-show");
  //     }, function(){
  //     $(this).find(".box-infos").removeClass("bloco-foto-show");
  // });

  if ($(window).width() <= LARGURA_MOBILE) {
    $blocoFromMobile.remove();
    videoScreenTarget = "mobile";
  } else {
    $blocoUntilMobile.remove();
  }

  $iframeVideo.each(function () {
    var code = $(this).data("code");
    $(this).attr(
      "src",
      "https://www.youtube-nocookie.com/embed/" + code + "?rel=0"
    );
  });

  // mostra elementos no scroll
  mostraBlocosVideos();

  $(window).scroll(function () {
    mostraBlocosVideos();
  });
});

function targetAcaoVideos(target) {
  var offset = forceShow ? 50 : 100;

  if (!forceShow) {
    forceShow = true;
    $blocoVideos.addClass("bloco-show");
  }

  target += "-" + videoScreenTarget;

  scrollToAnchor(target, offset);

  $blocoVideos.css("opacity", "0.5");
  $("#" + target).css("opacity", "1");
  $("#" + target).addClass(clssBlocoHighlight);

  setTimeout(function () {
    $blocoVideos.css("opacity", "1");
    $("#" + target).removeClass(clssBlocoHighlight);
  }, 3000);
}

function mostraBlocosVideos() {
  if (forceShow) return;

  $blocoVideos.each(function () {
    if ($(this).css("opacity") == 0 && isInView($(this)))
      $(this).addClass("bloco-show");
  });
}
